import { axiosApi } from "../../../api/dbAxios";
import { IRole } from "../interfaces/team.interface";

export const createTeam = async (
  name: string,
  regulators: any[],
  roles: IRole[],
  requestsLimit?: number,
) => {
  const body = {
    roles: roles,
    name,
    regulators,
    requests_limit: requestsLimit,
  };
  try {
    const response = await axiosApi.post("/teams/", body);
    return response.data;
  } catch (error) {
    console.error("Error updating user role:", error);
    return [];
  }
};
